/**
 * 货币格式化工具函数
 * 统一项目内所有金额字段的展示格式
 */

/**
 * 将数值格式化为 USD 货币字符串
 * @param {number|string|null|undefined} value - 要格式化的数值
 * @returns {string} 格式化后的货币字符串，无效输入返回 "-"
 */
export function formatUSD(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  const num = Number(value);
  if (isNaN(num)) {
    return String(value);
  }
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
